'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

type PublicProfileContextType = {
  preferredUsername: string
}

const PublicProfileContext = createContext<PublicProfileContextType | null>(null)

type PublicProfileProviderProps = PropsWithChildren<{
  preferredUsername: string
}>

export function PublicProfileProvider({
  children,
  preferredUsername,
}: PublicProfileProviderProps) {
  return (
    <PublicProfileContext.Provider
      value={{
        preferredUsername,
      }}
    >
      {children}
    </PublicProfileContext.Provider>
  )
}

export const usePublicProfileContext = () => {
  const value = useContext(PublicProfileContext)

  if (value == null) {
    throw new Error('usePublicProfileContext cannot be used outside of PublicProfileProvider')
  }

  return value
}
